var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 20,
  fill: "none",
  viewBox: "0 0 11 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M10.719 1.697A1.002 1.002 0 0 0 9.303.28L.293 9.292a1 1 0 0 0 0 1.416l9.01 9.01a1.001 1.001 0 0 0 1.416-1.415L2.417 10z"
})));
export default SvgFacebookMobileReelChevronLeft;